
    angular.module('v3sWbtPlayerApp').value('v3sSupportedLanguages', {
    
      'de': 'textlibrary.de.min.js',
      'en': 'textlibrary.en.min.js',
      'it': 'textlibrary.it.min.js',
      'fr': 'textlibrary.fr.min.js',
      'pl': 'textlibrary.pl.min.js',
      'ru': 'textlibrary.ru.min.js',
      'cs': 'textlibrary.cs.min.js',
      'es': 'textlibrary.es.min.js',
      'pt': 'textlibrary.pt.min.js',
      'sk': 'textlibrary.sk.min.js',
      'tr': 'textlibrary.tr.min.js',
      'zh': 'textlibrary.zh.min.js'
    });
  